<template>
    <div class="d-flex justify-center my-6">
        <v-btn
            @click="$router.push('/user/purchases')"
            x-large
            block
            class="premium-btn-outline px-6 py-7 max-width-button"
            v-if="purchases.length"
        >
            <div class="d-flex align-center justify-space-between width-100">
                <div class="d-flex align-center">
                    <v-icon color="#00B074" class="mr-3">mdi-cash-multiple</v-icon>
                    <span class="white--text font-weight-bold">Deine Einkäufe ({{ purchases.length }})</span>
                </div>
                <v-icon color="#00B074">mdi-chevron-right</v-icon>
            </div>
        </v-btn>
    </div>
</template>
   
<script>
import api from '@/api'

export default {
    data() {
        return {
            purchases: [],
        }
    },
    async created() {
        this.purchases = await api.fetchAllPurchases()
    },
}
</script>

<style scoped>
@import './shopCommon.css';

.max-width-button {
    max-width: 400px !important;
    width: 100%;
}
.width-100 {
    width: 100%;
}
</style>

  